import React from "react";
import  './componentsmedia.css';

function Footer() {
    return(
        <div className={'footerdata'}>
            <div className={'attribution'}>Developed By Amit Kumar Rout</div>
        </div>
    )
}

export default Footer